"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGetInTouch = void 0;
exports.defaultGetInTouch = {
    address: '15/F, Wilson House, 19-27 Wyndham Street<br>Central, Hong Kong',
    tel: '(+852) 2102 0888',
    email: 'cs@okay.com',
    linkFacebook: 'https://www.facebook.com/OKAYDOTCOM',
    linkInstagram: 'https://www.instagram.com/okay.comhk/',
    linkLinkedIn: 'https://www.linkedin.com/company/okay-com',
};
